// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatetimepickerController from "./datetimepicker_controller"
application.register("datetimepicker", DatetimepickerController)

import Share__FacebookController from "./share/facebook_controller"
application.register("share--facebook", Share__FacebookController)

import Share__TwitterController from "./share/twitter_controller"
application.register("share--twitter", Share__TwitterController)

import Survey__AutocompleteController from "./survey/autocomplete_controller"
application.register("survey--autocomplete", Survey__AutocompleteController)

import Survey__Bmi__HeightController from "./survey/bmi/height_controller"
application.register("survey--bmi--height", Survey__Bmi__HeightController)

import Survey__Bmi__WeightController from "./survey/bmi/weight_controller"
application.register("survey--bmi--weight", Survey__Bmi__WeightController)

import Survey__CheckboxController from "./survey/checkbox_controller"
application.register("survey--checkbox", Survey__CheckboxController)

import Survey__DatePickerController from "./survey/date_picker_controller"
application.register("survey--date-picker", Survey__DatePickerController)

import Survey__DateRangePickerController from "./survey/date_range_picker_controller"
application.register("survey--date-range-picker", Survey__DateRangePickerController)

import Survey__Eq5dVasController from "./survey/eq5d_vas_controller"
application.register("survey--eq5d-vas", Survey__Eq5dVasController)

import Survey__RadioController from "./survey/radio_controller"
application.register("survey--radio", Survey__RadioController)

import Survey__SliderController from "./survey/slider_controller"
application.register("survey--slider", Survey__SliderController)
